export default { sha: '10c4850e2435e2814e6e34edba86797b5f5276f1', buildNumber: 'undefined' }
